import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function Consultation() {
  return <ServiceDetailPage service={servicePageContent.consultation} />;
}
